import { useCallback } from "react";
import { usePriceDelta } from "./usePriceDelta";
import { getPriceWithCurrency } from "../utils/formatPrice";

export function useFinalItemPrice() {
  const { getPriceDelta, activeBucket } = usePriceDelta();

  const getPriceFinal = useCallback(
    (price: number): string | undefined => {
      if (!activeBucket) return;

      if (activeBucket.relation?.uid === "teak_natural") {
        return getPriceWithCurrency(price, "+");
      }

      if (activeBucket.relation?.uid === "metallic") {
        return getPriceWithCurrency(price, "+");
      }

      const hasPositivePrice = activeBucket.items.some((sub) => sub.price > 0);

      if (hasPositivePrice) {
        return getPriceDelta(price);
      }

      return undefined;
    },
    [activeBucket, getPriceDelta],
  );

  return { getPriceFinal };
}
